import type { ComponentType } from 'react';

import { useIsDesktop } from '@/hooks/useIsDesktop';

export interface WithResponsiveProps {
  isDesktop: boolean;
  isMobile: boolean;
}

export function withResponsive<P extends object>(
  Component: ComponentType<P & WithResponsiveProps>
) {
  return function ResponsiveComponent(props: P) {
    const { isDesktop, isMobile } = useIsDesktop();

    return <Component {...props} isDesktop={isDesktop} isMobile={isMobile} />;
  };
}
